import { nanoid } from 'nanoid';

// HEAD DATA
export const headData = {
  title: '', // e.g: 'Name | Developer'
  lang: '', // e.g: en, es, fr, jp
  description: '', // e.g: Welcome to my website
};

// HERO DATA
export const heroData = {
  title: '',
  name: '',
  subtitle: '',
  cta: '',
};

// ABOUT DATA
export const aboutData = {
  img: 'profile.png',
  paragraphOne: 'FocusGroup was founded to provide a platform for students, fresh graduates, and experienced hires to collectively solve business problems while developing pragmatic, innovative business solutions across our vast network of business clientele.  ',
  paragraphTwo: 'We are currently not running competitions and will be building up to them over time.',
  paragraphThree: 'For now, please keep an eye out for our Focus Sessions which will be 30-40 minute long group mentorship sessions with successful professionals! ',
  resume: 'https://www.resumemaker.online/es.php', // if no resume, the button will not show up
};

// PROJECTS DATA
export const projectsData = [
  {
    id: nanoid(),
    img: 'step1.png',
    title: 'Plan Your Pitch',
    info: 'You will receive a specific or open case question alongside a time-frame to plan your answer. You are encouraged to think outside the box as much as possible!',
    info2: '',
    url: '',
    repo: 'https://github.com/cobidev/react-simplefolio', // if no repo, the button will not show up
  },
  {
    id: nanoid(),
    img: 'step2.png',
    title: 'Deliver It',
    info: 'Once the blueprint is nailed, on our platform you will be given a allotted time-frame to deliver your pitch to a closed panel of judges.    ',
    info2: '',
    url: '',
    repo: 'https://github.com/cobidev/react-simplefolio', // if no repo, the button will not show up
  },
  {
    id: nanoid(),
    img: 'step3.png',
    title: 'Feedback',
    info: 'Upon completion, you will be given tailored feedback on your answer with areas for improvement, in the coming few days.     ',
    info2: '',
    url: '',
    repo: 'https://github.com/cobidev/react-simplefolio', // if no repo, the button will not show up
  },
  {
    id: nanoid(),
    img: 'step4.png',
    title: 'Benefit',
    info: 'Once you have received your feedback, the best submissions will be given the opportunity to join a free case training course, honing their skills for pragmatic, business use.    ',
    info2: '',
    url: '',
    repo: 'https://github.com/cobidev/react-simplefolio', // if no repo, the button will not show up
  },
];

// CONTACT DATA
export const contactData = {
  cta: '',
  btn: '',
  email: '',
};

// FOOTER DATA
export const footerData = {
  networks: [
    {
      id: nanoid(),
      name: 'instagram',
      url: 'https://www.instagram.com/focusconsultgrow/',
    },
    {
      id: nanoid(),
      name: 'facebook',
      url: 'https://www.facebook.com/FocusConsultGrow/',
    },
    {
      id: nanoid(),
      name: 'linkedin',
      url: 'https://www.linkedin.com/company/focusgroup-io/',
    },
   
  ],
};

// Github start/fork buttons
export const githubButtons = {
  isEnabled: false, // set to false to disable the GitHub stars/fork buttons
};
